import { ApiService } from './api';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Language } from './static-data/language';

@Injectable({ providedIn: 'root' })
export class LanguagesService {
  constructor(private apiService: ApiService) { }

  getLanguages(): Observable<Language[]> {
    return this.apiService.get<Language[]>('/api/locales').pipe(
      map(languages => {
        languages.sort((a, b) => a.name.localeCompare(b.name));
        return languages;
      }),
      catchError(() => of([])),
      shareReplay({ bufferSize: 1, refCount: true})
    );
  }
}
